import {
  AVALIACOES_QUESTOES_LIST,
  AVALIACOES_QUESTOES_READ,
  AVALIACOES_QUESTOES_ADD,
  AVALIACOES_QUESTOES_MODIFY,
  AVALIACOES_QUESTOES_REMOVE,
} from "../const/servicesURI";
import requestService from "./requestService";
import { httpRequests } from "investira.sdk";
import utils from "../utils";

const cancel = {
  list: null,
  read: null,
};

export const list = (pParams, pResolve, pReject, pFinally) => {
  if (cancel.list) {
    cancel.list.cancel();
  }

  cancel.list = httpRequests.cancelToken();

  const xProps = {
    params: pParams,
    cancelToken: cancel.list.token,
  };

  return requestService(xProps, AVALIACOES_QUESTOES_LIST, 3)
    .then((rRes) => {
      return pResolve && pResolve(rRes);
    })
    .catch((rErr) => {
      utils.request.tracer(rErr, "Error Service Questoes List");
      return pReject && pReject(rErr);
    })
    .finally(() => {
      pFinally && pFinally();
    });
};

export const read = (pQuestaoId, pResolve, pReject, pFinally) => {
  if (cancel.read) {
    cancel.read.cancel();
  }

  cancel.read = httpRequests.cancelToken();

  const xProps = {
    cancelToken: cancel.read.token,
  };

  return requestService(xProps, `${AVALIACOES_QUESTOES_READ}/${pQuestaoId}`, 3)
    .then((rRes) => {
      return pResolve && pResolve(rRes);
    })
    .catch((rErr) => {
      utils.request.tracer(rErr, "Error Service Questoes Read");
      return pReject && pReject(rErr);
    })
    .finally(() => {
      pFinally && pFinally();
    });
};

export const add = (pData, pResolve, pReject, pFinally) => {
  const xProps = {
    data: pData,
    method: "POST",
  };

  return requestService(xProps, AVALIACOES_QUESTOES_ADD, 3)
    .then((rRes) => {
      return pResolve && pResolve(rRes);
    })
    .catch((rErr) => {
      utils.request.tracer(rErr, "Error Service Questoes Add");
      return pReject && pReject(rErr);
    })
    .finally(() => {
      pFinally && pFinally();
    });
};

export const modify = (pData, pResolve, pReject, pFinally) => {
  const xProps = {
    data: pData,
    method: "PATCH",
  };

  return requestService(xProps, AVALIACOES_QUESTOES_MODIFY, 3)
    .then((rRes) => {
      return pResolve && pResolve(rRes);
    })
    .catch((rErr) => {
      utils.request.tracer(rErr, "Error Service Questoes Modify");
      return pReject && pReject(rErr);
    })
    .finally(() => {
      pFinally && pFinally();
    });
};

export const remove = (pData, pResolve, pReject, pFinally) => {
  const xProps = {
    data: pData,
    method: "DELETE",
  };

  return requestService(xProps, AVALIACOES_QUESTOES_REMOVE, 3)
    .then((rRes) => {
      return pResolve && pResolve(rRes);
    })
    .catch((rErr) => {
      utils.request.tracer(rErr, "Error Service Questoes Remove");
      return pReject && pReject(rErr);
    })
    .finally(() => {
      pFinally && pFinally();
    });
};

const questoes = { list, read, add, modify, remove, cancel };

export default questoes;
